export default "__VITE_ASSET__BWJtOKKF__"